import { render } from "./EmpresasCatering.vue?vue&type=template&id=209962a9&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./EmpresasCatering.vue?vue&type=script&lang=js"
export * from "./EmpresasCatering.vue?vue&type=script&lang=js"
script.render = render

export default script